import type { ComponentProps } from "react";

const ThreeDotsIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="4"
      height="13"
      viewBox="0 0 4 13"
      fill="currentColor"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2" cy="2" r="1.5" />
      <circle cx="2" cy="6.5" r="1.5" />
      <circle cx="2" cy="11" r="1.5" />
    </svg>
  );
};

export default ThreeDotsIcon;
